import { Button, Typography } from "antd";
import { LeftOutlined } from "@ant-design/icons";

const { Text } = Typography;

interface AppBarCustomProps {
    title: string;
    handleBack: () => void;
}

export const AppBarCustom = ({ title, handleBack }: AppBarCustomProps) => {
    return (
        <div style={{ padding: 0 }}>
            <div
                style={{
                    height: 48,
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "white",
                }}
            >
                <Button
                    type="text"
                    icon={<LeftOutlined />}
                    onClick={handleBack}
                    style={{
                        width: 40,
                        height: 40,
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                />

                <Text
                    style={{
                        marginLeft: 4,
                        fontSize: 17,
                        lineHeight: "24px",
                        fontWeight: 700
                    }}
                >
                    {title}
                </Text>
            </div>


        </div>
    );
};
